// The Boos page shows either a plain list or the org-chart diagram. Small orgs
// start on the list, where each Boo has an Open button; bigger ones start on
// the diagram. A choice the user makes sticks per org, in this browser.

export type BoosView = "list" | "diagram";

// The most Boos an org can have and still start on the list.
const LIST_DEFAULT_MAX = 2;

export function isBoosView(value: unknown): value is BoosView {
  return value === "list" || value === "diagram";
}

export function defaultBoosView(booCount: number): BoosView {
  return booCount <= LIST_DEFAULT_MAX ? "list" : "diagram";
}

const key = (orgId: string) => `boo.boos-view.${orgId}`;

export function storedBoosView(orgId: string): BoosView | null {
  try {
    const value = localStorage.getItem(key(orgId));
    return isBoosView(value) ? value : null;
  } catch {
    return null;
  }
}

export function storeBoosView(orgId: string, view: BoosView): void {
  try {
    localStorage.setItem(key(orgId), view);
  } catch {
    // Storage blocked: the choice lasts until the page reloads.
  }
}
